module.exports = __webpack_public_path__ + "img/ios-icon.8a461845.svg";